import {
    Alert,
    Box,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography
} from "@mui/material";
import CurrencyFormatter from "../../../../../components/CurrencyFormatter/CurrencyFormatter";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {UPDATE_PAYMENT_MUTATION} from "../../../../../store/mutations/UpdatePayment";
import {useMutation, useQuery} from "@apollo/client";
import {UseQuerySuspense} from "../../../../../components/UseQuerySuspense/UseQuerySuspense";
import {GET_USER} from "../../../../../store/queries/GetUser";
import {paymentMethodIcon} from "./PaymentMethod";
import CheckSharpIcon from "@mui/icons-material/CheckSharp";
import DoDisturbRoundedIcon from "@mui/icons-material/DoDisturbRounded";
import {format} from "date-fns";
import {
    GetUserQuery,
    PaymentTxStatus,
    UpdatePaymentMutationMutation,
    UpdatePaymentMutationMutationVariables,
    User
} from "../../../../../gql/graphql";

export const UpdatePayment = (props: { paymentId: string }) => {
    const {t} = useTranslation();

    const {loading, error, data} = useQuery<GetUserQuery>(GET_USER);
    const [updatePayment, updatePaymentState] = useMutation<UpdatePaymentMutationMutation, UpdatePaymentMutationMutationVariables>(UPDATE_PAYMENT_MUTATION, {
        update(cache, {data}) {
            cache.writeQuery({
                data: {identity: data?.updatePayment?.user},
                query: GET_USER
            });
        }
    });

    useEffect(() => {
        updatePayment({
            variables: {
                paymentId: props.paymentId
            },
            onCompleted(data) {
                (window as any).dataLayer = (window as any).dataLayer || [];
                if (data?.updatePayment?.paymentInformation?.status == PaymentTxStatus.Completed)
                    (window as any).dataLayer.push({
                        'event': 'depositSuccess',
                        'value': data?.updatePayment?.paymentInformation?.amount,
                        'currency' : 'EUR'
                    });
                else
                    (window as any).dataLayer.push({
                        'event': 'depositFailed'
                    });
            },
            onError(data) {
            }

        })
    }, []);

    return (


        <UseQuerySuspense data={updatePaymentState}>
            <Paper sx={{p: 2, mt: '0 !important'}}>

                {(updatePaymentState.data?.updatePayment?.paymentInformation?.status == PaymentTxStatus.Completed || updatePaymentState.data?.updatePayment?.paymentInformation?.status == PaymentTxStatus.Collected) && (
                    <Box sx={{
                        color: (theme) => theme.palette.success.main,
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <CheckSharpIcon sx={{flexBasis: '100%', height: 64, width: 64}}/>
                        <Typography variant={'body1'}
                                    sx={{flexBasis: '100%', display: 'flex', justifyContent: 'center', mt: 1}}>
                            {t('thankYouForYourDeposit')}
                        </Typography>
                        {(data?.identity as User | null)?.hasAffiliate && (
                            <iframe style={{display:'none'}} src={`https://wlpeppermill.adsrv.eacdn.com/Processing/Pixels/Sales.ashx?PlayerID=${(data?.identity as User | null)?.id}&mid=2&saleid=${props.paymentId}&dpst=${updatePaymentState.data?.updatePayment?.paymentInformation?.amount}`}></iframe>)}
                    </Box>
                )}
                {(updatePaymentState.data?.updatePayment?.paymentInformation?.status == PaymentTxStatus.Started ||updatePaymentState.data?.updatePayment?.paymentInformation?.status == PaymentTxStatus.InProcess || updatePaymentState.data?.updatePayment?.paymentInformation?.status == PaymentTxStatus.Failed || updatePaymentState.data?.updatePayment?.paymentInformation?.status == PaymentTxStatus.Refused) && (
                    <Box sx={{
                        color: (theme) => theme.palette.error.main,
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <DoDisturbRoundedIcon sx={{flexBasis: '100%', height: 64, width: 64}}/>
                        <Typography variant={'body1'}
                                    sx={{
                                        flexBasis: '100%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        mt: 1
                                    }}>{t('depositCouldNotBeCompleted')}</Typography>
                    </Box>
                )}
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minWidth: 300
                }}>
                    <TableContainer sx={{mt: 2}}>
                        <Table>
                            <TableBody sx={{'& tr td': {border: 0}}}>

                                <TableRow>
                                    <TableCell align="right" sx={{fontWeight: 700}}>{t('id')}</TableCell>
                                    <TableCell align="left">
                                        {props.paymentId}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="right" sx={{fontWeight: 700}}>{t('paymentMethod')}</TableCell>
                                    <TableCell align="left">
                                        {paymentMethodIcon(updatePaymentState.data?.updatePayment?.paymentInformation?.method?.name as string, true)}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="right" sx={{fontWeight: 700}}>{t('date')}</TableCell>
                                    <TableCell align="left">
                                        {!(updatePaymentState.data?.updatePayment?.paymentInformation?.status == PaymentTxStatus.Completed || updatePaymentState.data?.updatePayment?.paymentInformation?.status == PaymentTxStatus.Collected) && (
                                            <>   {updatePaymentState.data?.updatePayment?.paymentInformation?.timestamp && (<>{format(new Date(updatePaymentState.data?.updatePayment?.paymentInformation?.timestamp), 'yyyy-MM-dd HH:mm:ss')}</>)}</>

                                        )}
                                        {(updatePaymentState.data?.updatePayment?.paymentInformation?.status == PaymentTxStatus.Completed || updatePaymentState.data?.updatePayment?.paymentInformation?.status == PaymentTxStatus.Collected) && (

                                            <>   {updatePaymentState.data?.updatePayment?.paymentInformation?.creditTxTimestamp && (<>{format(new Date(updatePaymentState.data?.updatePayment?.paymentInformation?.creditTxTimestamp), 'yyyy-MM-dd HH:mm:ss')}</>)}</>
                                        )}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="right" sx={{fontWeight: 700}}>{t('amount')}</TableCell>
                                    <TableCell align="left">
                                        <CurrencyFormatter
                                            quantity={updatePaymentState.data?.updatePayment?.paymentInformation?.amount}
                                            currency={"EUR"}/>
                                    </TableCell>
                                </TableRow>
                                {!(updatePaymentState.data?.updatePayment?.paymentInformation?.status == PaymentTxStatus.Completed || updatePaymentState.data?.updatePayment?.paymentInformation?.status == PaymentTxStatus.Collected) && (
                                    <TableRow>
                                        <TableCell align="right" sx={{fontWeight: 700}}>{t('status')}</TableCell>
                                        <TableCell align="left">
                                            {updatePaymentState.data?.updatePayment?.paymentInformation?.status}
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Paper>


        </UseQuerySuspense>
    );
}